export default {
      id: "exchange-alt-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#exchange-alt",
      toString: function () {
        return this.url;
      }
    }